import { ScreenCategoryApi } from './../../../../../shared/sdk/services/custom/ScreenCategory';
import { ScreenCategory } from './../../../../../shared/sdk/models/ScreenCategory';
import { RotationItemApi, Screen, ScreenApi } from '../../../../../shared/sdk/index';
import { LoggerService } from './../../../../../shared/sdk/services/custom/logger.service';
import { ScheduleTimeframeApi } from './../../../../../shared/sdk/services/custom/ScheduleTimeframe';
import { CategoryRotationApi } from './../../../../../shared/sdk/services/custom/CategoryRotation';
import { Calendar } from 'primeng/primeng';
import { CategoryRotation } from './../../../../../shared/sdk/models/CategoryRotation';
import { ScheduleTimeframe } from './../../../../../shared/sdk/models/ScheduleTimeframe';
import { RotationItem } from './../../../../../shared/sdk/models/RotationItem';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
@Component({
  selector: 'app-timeline-dialog',
  templateUrl: './timeline-dialog.component.html',
  styleUrls: ['./timeline-dialog.component.css']
})
export class TimelineDialogComponent implements OnInit {

  // timeframe binding prop
  @Input() timeframe = new ScheduleTimeframe();
  @Output() timeframeChange = new EventEmitter();
  public weekStartsIndex = 0;

  //#region days of the week
  public const_days = [{
    id: 0,
    name: 'SUN',
    isSelected: false
  }, {
    id: 1,
    name: 'MON',
    isSelected: false
  }, {
    id: 2,
    name: 'TUE',
    isSelected: false
  }, {
    id: 3,
    name: 'WED',
    isSelected: false
  }, {
    id: 4,
    name: 'THU',
    isSelected: false
  }, {
    id: 5,
    name: 'FRI',
    isSelected: false
  }, {
    id: 6,
    name: 'SAT',
    isSelected: false
  }];

  //#endregion

  @Output() onSave = new EventEmitter();

  // visible binding prop
  public visibleVal: boolean;
  @Output() visibleChange = new EventEmitter();
  @Input()
  get visible() {
    return this.visibleVal;
  }

  set visible(val) {
    if (val) {
      // initilize on show
      if (!this.timeframe) {
        this.timeframe = this.createDefault();
      }

      // normailize dates into "date" type. Since for some reason they are strings sometimes?
      this.timeframe.start = new Date(this.timeframe.start);
      this.timeframe.end = new Date(this.timeframe.end);
      this.timeframe.endTime = new Date(this.timeframe.endTime);
      this.timeframe.startTime = new Date(this.timeframe.startTime);
      if (this.timeframe.specificDates) {
        this.timeframe.specificDates = this.timeframe.specificDates.map((sd: any) => { return new Date(sd); });
      }

      // show selected days on load
      if (this.timeframe.repeatDays) {
        this.const_days.forEach(cd => {
          if (this.timeframe.repeatDays.indexOf(cd.id) !== -1) {
            cd.isSelected = true;
          } else {
            cd.isSelected = false;
          }
        });
        // this.timeframe.repeatDays.forEach(rd => { this.const_days[rd].isSelected = true; });
      } else {
        this.timeframe.repeatDays = [];
      }

    } else {
      this.timeframe = null;
    }


    this.visibleVal = val;
    this.visibleChange.emit(this.visibleVal);
  }


  constructor(
    public logger: LoggerService,
  ) { }

  ngOnInit() {

    // setup defaults if bound to null
    this.doCalendarHack();

  }


  createDefault() {
    // create new timeframe with defaults
    const timeframe = new ScheduleTimeframe();

    // set the correct parent field (but we dont have this yet?)  so will need updated in the return function on parent component
    // for category rotation
    // this.timeframe.categoryRotationId = categoryRotation.id;

    // for rotation item
    // timeframe.rotationitemId = rotationitem.id;

    timeframe.inverse = false;
    timeframe.start = new Date();

    timeframe.hasEnd = false;
    timeframe.end = new Date();

    // playmode options
    timeframe.playMode = 'inTurn';
    timeframe.minTimeBetweenPlays = 0;
    timeframe.forcePlayTime = 1;

    timeframe.repeat = true; // repeat days of week
    timeframe.repeatFrequency = 1;
    timeframe.repeatDays = [0, 1, 2, 3, 4, 5, 6]; // if mode repeat is used
    timeframe.specificDates = null; // end will be last date specified

    timeframe.specificTime = false;
    timeframe.startTime = new Date('December 17, 2017 08:00:00');
    timeframe.endTime = new Date('December 17, 2017 17:00:00');

    return timeframe;
  }



  doCalendarHack() {
    // HACK - OVERRIDE control to initialize multiple dates properly
    Calendar.prototype.updateUI = function () {
      const val = this.value || this.defaultDate || new Date();

      if (Array.isArray(val)) {
        if (val.length > 0) { this.createMonth(val[0].getMonth(), val[0].getFullYear()); }
      } else {
        this.createMonth(val.getMonth(), val.getFullYear());
      }

      if (this.showTime || this.timeOnly) {
        const hours = val.getHours();
        if (this.hourFormat === '12') {
          if (hours >= 12) {
            this.currentHour = (hours === 12) ? 12 : hours - 12;
          } else {
            this.currentHour = (hours === 0) ? 12 : hours;
          }
        } else {
          this.currentHour = val.getHours();
        }
        this.currentMinute = val.getMinutes();
        this.currentSecond = val.getSeconds();
      }
    };
  }


  saveTimeframe() {
    this.onSave.emit(this.timeframe);
  }

  onDayClicked(index) {
    this.const_days[index].isSelected = !this.const_days[index].isSelected;

    // add day to list
    if (this.timeframe.repeatDays.indexOf(index) === -1 && this.const_days[index].isSelected) {
      this.timeframe.repeatDays.push(index);
    }

    // remove day from list
    if (this.timeframe.repeatDays.indexOf(index) !== -1 && !this.const_days[index].isSelected) {
      this.timeframe.repeatDays.splice(this.timeframe.repeatDays.indexOf(index), 1);
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/scheduling/components/timeline-dialog/timeline-dialog.component.ts